import React, { useState } from 'react';

const FinanceCalculator = ({ price }) => {
  const [deposit, setDeposit] = useState(Math.round(price * 0.1));
  const [term, setTerm] = useState(48);
  const rate = 7.9;

  const calculateMonthly = () => {
    const amount = price - deposit;
    const monthlyRate = rate / 100 / 12;
    const payment = (amount * monthlyRate * Math.pow(1 + monthlyRate, term)) / 
                   (Math.pow(1 + monthlyRate, term) - 1);
    return Math.round(payment);
  };

  const monthlyPayment = calculateMonthly();
  const totalPayable = monthlyPayment * term + deposit;

  return (
    <div className="finance-calculator">
      <h3>Finance Calculator</h3>
      <div className="calculator-form">
        <div className="calc-group">
          <label>Cash Price</label>
          <div className="calc-value highlight">£{price.toLocaleString()}</div>
        </div>
        
        <div className="calc-group">
          <label>Deposit: £{deposit.toLocaleString()}</label>
          <input 
            type="range" 
            min="0" 
            max={price * 0.5} 
            step="100"
            value={deposit}
            onChange={(e) => setDeposit(Number(e.target.value))}
            className="slider"
          />
          <div className="slider-labels">
            <span>£0</span>
            <span>£{(price * 0.25).toLocaleString()}</span>
            <span>£{(price * 0.5).toLocaleString()}</span>
          </div>
        </div>

        <div className="calc-group">
          <label>Term</label>
          <div className="term-buttons">
            {[24, 36, 48, 60].map(t => (
              <button 
                key={t}
                className={term === t ? 'active' : ''}
                onClick={() => setTerm(t)}
              >
                {t}m
              </button>
            ))}
          </div>
        </div>

        <div className="calc-result-box">
          <div className="monthly-payment">
            <span className="currency">£</span>
            <span className="amount">{monthlyPayment}</span>
            <span className="period">/mo</span>
          </div>
          <div className="calc-details">
            <div className="calc-row">
              <span>APR Representative</span>
              <span>{rate}%</span>
            </div>
            <div className="calc-row">
              <span>Total Payable</span>
              <span>£{totalPayable.toLocaleString()}</span>
            </div>
            <div className="calc-row">
              <span>Total Credit</span>
              <span>£{(price - deposit).toLocaleString()}</span>
            </div>
          </div>
        </div>
        
        <button className="btn btn-primary full-width">Apply for Finance</button>
        <p className="calc-disclaimer">Finance subject to status. Ts&Cs apply.</p>
      </div>
    </div>
  );
};

export default FinanceCalculator;
